import React, { useEffect, useState } from "react";
import LoadingBtn from "../../Widgets/LoadingBtn";
import { AlertNotif } from "../../../Library/AlertNotif";
import { REQUEST_TARGET_MODULES } from "../../../Library/APIsTarget";
import TableSemesterCourse from "./TableSemesterCourse";

export default function TableCurriculums({ param }) {
  const [result, setResult] = useState({
    loading: false,
    data: [],
    message: "",
  });
  const ReloadData = async () => {
    setResult({ loading: true, data: [], message: "" });
    const param_post = {
      parameters: param,
      target_data: "PROGRESS_CURR",
    };

    const results = await REQUEST_TARGET_MODULES(param_post);
    if (results.data && Object.values(results.data).length > 0) {
      setResult({ loading: false, data: results.data, message: "" });
    } else {
      setResult(results);
    }
  };
  useEffect(() => {
    ReloadData();
  }, []);

  return result.loading ? (
    <LoadingBtn />
  ) : result.message ? (
    <AlertNotif message={result.message} color={"danger"} />
  ) : Object.values(result.data).length > 0 ? (
    <div className="card card-custom card-stretch gutter-b">
      <div className="card-body">
        <div className="d-flex justify-content-between">
          <div className="curr-info w-100">
            <h1>{result.data?.name}</h1>
            <div className="h-3 font-weight-bold">
              {result.data.curr_type &&
                Object.values(result.data.curr_type).length > 0 && (
                  <>
                    <DegreeType curr_data={result.data.curr_type} />
                    <span className="mx-2">·</span>
                  </>
                )}
              {result.data.clu && <span>{result.data.clu?.name}</span>}
              {result.data.clu_spec && (
                <>
                  <span className="mx-2">·</span>
                  <span>{result.data.clu_spec?.name}</span>
                </>
              )}
            </div>
          </div>
          <div className="w-350px">
            <span className="d-block font-weight-bold">
              Curriculum Progress
            </span>
            <StudentProgressBar data={result.data} />
          </div>
        </div>

        <div className="my-5">
          <TotalCalculate
            data={{
              totalMandatory: result.data?.t_mandatory || 0,
              totalElective: result.data?.t_elective || 0,
              totalCredit: result.data?.t_credit || 0,
            }}
          />
        </div>

        <TableSemesterCourse data={result.data} />
      </div>
    </div>
  ) : (
    ""
  );
}

const StudentProgressBar = ({ data }) => {
  const percentageDone = data.percentage.toFixed(0);
  const current_credit = data?.t_credit_taken || 0;
  const sisa = data.t_credit - current_credit;
  if (sisa > 0) {
    return (
      <div className="d-flex align-items-center">
        {percentageDone < 100 ? (
          <div className="progress progress-xs mt-2 mb-2 w-100 h-20px">
            {data.t_credit_taken > 0 ? (
              <div
                className="progress-bar rounded-left-0 bg-primary text-white fw-bolder"
                title="Credit taken"
                role="progressbar"
                style={{
                  width: percentageDone + "%",
                  height: "20px",
                }}
              >
                {current_credit}
              </div>
            ) : (
              ""
            )}
            <div
              className="progress-bar rounded-left-0 bg-light text-muted fw-bolder"
              role="progressbar"
              title="Remaining Credit"
              style={{ width: (100-percentageDone) + "%", height: "20px" }}
            >
              {sisa}
            </div>
          </div>
        ) : (
          <div className="progress progress-xs mt-2 mb-2 w-100 h-20px">
            <div
              className="progress-bar rounded-left-0 bg-primary"
              title="Finish"
              role="progressbar"
              style={{ width: "100%", height: "20px" }}
            >
              {data.t_credit_taken}
            </div>
          </div>
        )}
        <span className="ml-2 text-gray-500 font-weight-semibold">
          {percentageDone}%
        </span>
      </div>
    );
  } else {
    return (
      <div className="d-flex align-items-center">
        <div className="progress progress-xs mt-2 mb-2 w-100 h-20px" />
        <span className="ml-2 text-gray-500 font-weight-bold">0%</span>
      </div>
    );
  }
};

const DegreeType = ({ curr_data }) => {
  const degree_type = curr_data
    ? curr_data.map((i) => ({
        label: i.t_curr_type[0]?.name || i.t_curr_type[0]?.id,
        value: i.t_curr_type_id,
        id: i.id,
      }))
    : [];
  return <span>{degree_type?.map((i) => i.label)?.join(", ")}</span>;
};

const TotalCalculate = ({ data }) => {
  return (
    <div className="d-flex align-items-center justify-content-between bg-light rounded p-5">
      <LabelTotalData
        title={"Total Mandatory Courses"}
        value={`${data.totalMandatory} SKS`}
      />
      <LabelTotalData
        title={"Total Elective Courses"}
        value={`${data.totalElective} SKS`}
      />
      <LabelTotalData
        title={"Total Curriculum Credits"}
        value={`${data.totalCredit} SKS`}
      />
    </div>
  );
};

const LabelTotalData = ({ title, value }) => {
  return (
    <div className="item font-weight-bolder">
      <span className="mr-1">{title}:</span>
      <span>{value}</span>
    </div>
  );
};
